import * as tokenService from './token'
import { getCurrentLanguage } from '../language/services'
import { ApiResponse, ApiRequest } from '../../modules/types'
import { HttpError } from '../errors'

export async function createHeaders() {
  const headers: { [key: string]: string } = {
    'Accept': 'application/vnd.papertrail.api+json; version=1.0',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }

  const token = tokenService.loadToken()

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const currentLanguage = getCurrentLanguage()
  if (currentLanguage === 'en') {
    headers['Accept-Language'] = currentLanguage
  } else {
    headers['Accept-Language'] = currentLanguage + ',en'
  }

  return headers
}

export type FetchRequest = {
  path: string
  method: string
  body?: ApiRequest
}

export function withTimeout(ms: number, promise: Promise<ApiResponse>): Promise<ApiResponse> {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error('Promise timeout.'))
    }, ms)
    promise.then(
      (res: ApiResponse) => {
        clearTimeout(timeoutId)
        resolve(res)
      },
      (err: Error) => {
        console.log('error promise', err)
        clearTimeout(timeoutId)
        reject(err)
      }
    )
  })
}


export async function requestRaw(request: FetchRequest) {
  const headers = await createHeaders()
  const args: RequestInit = {
    method: request.method,
    body: JSON.stringify(request.body),
    headers
  }

  const timeoutMs = 25000
  let response: ApiResponse

  try {
    response = await (withTimeout(timeoutMs, fetch(new Request('/api' + request.path, args))))
  } catch {
    throw new HttpError(408, `time_out`, '', request)
  }

  if (response && response.ok) {
    return await response.text()
  } else {
    await handleError(request, response)
  }
}

export async function request(request: FetchRequest) {
  const headers = await createHeaders()
  const args: RequestInit = {
    method: request.method,
    body: JSON.stringify(request.body),
    headers
  }

  const timeoutMs = 25000
  let response: ApiResponse

  try {
    response = await (withTimeout(timeoutMs, fetch(new Request('/api' + request.path, args))))
  } catch (error) {
    // throw error
    throw new HttpError(408, `time_out`, '', request)
  }

  if (response && response.ok) {
    const text = await response.text()

    try {
      const json = JSON.parse(text)
      return json
    } catch{
      return text
    }
    
  } else {
    await handleError(request, response)
  }
}

async function handleError(request: FetchRequest, response: ApiResponse) {
  let details
  let code
  let message

  try {
    details = await response.json()
    code = details.error
    message = details.message
  } catch {
    message = response.text()
    code = "unknown"
  }

  throw new HttpError(response.status as number, code, message, request)
}
